"use strict";

var _regeneratorRuntime2 = require("@babel/runtime/regenerator");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contractorsWatcher = contractorsWatcher;
exports.createContractor = createContractor;
exports.createContractorType = createContractorType;
exports.deleteContractor = deleteContractor;
exports.deleteContractorType = deleteContractorType;
exports.disableContractorType = disableContractorType;
exports.editContractor = editContractor;
exports.editContractorFiles = editContractorFiles;
exports.editContractorType = editContractorType;
exports.enableContractorType = enableContractorType;
exports.getContractor = getContractor;
exports.listContractorTypes = listContractorTypes;
exports.listContractors = listContractors;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _effects = require("redux-saga/effects");
var _variables = require("../variables");
var _Contractor = require("../../../services/Contractor");
var _variables2 = require("../../Notification/variables");
var _utils = require("../../../utils");
var _helpers = require("@qwkin/helpers");
var _marked = /*#__PURE__*/_regeneratorRuntime2.mark(contractorsWatcher);
function editContractor(_ref) {
  var payload = _ref.payload,
    _ref$callback = _ref.callback,
    callback = _ref$callback === void 0 ? _helpers.identity : _ref$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var response, _response$data, _response$data2, _response;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(_Contractor.ContractorService.edit, payload);
        case 3:
          response = _context.sent;
          _context.next = 6;
          return (0, _effects.put)({
            type: _variables.CONTRACTORS_EDIT_SUCCESS,
            payload: response
          });
        case 6:
          _context.next = 8;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Contractor edited successfully'
            }
          });
        case 8:
          callback();
          _context.next = 19;
          break;
        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](0);
          _response = _context.t0.response;
          _context.next = 16;
          return (0, _effects.put)({
            type: _variables.CONTRACTORS_EDIT_FAIL,
            payload: _response
          });
        case 16:
          _context.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response$data = _response === null || _response === void 0 ? void 0 : _response.data) !== null && _response$data !== void 0 ? _response$data : {}),
              data: _response
            }
          });
        case 18:
          (0, _utils.logErr)((_response$data2 = _response === null || _response === void 0 ? void 0 : _response.data) !== null && _response$data2 !== void 0 ? _response$data2 : {});
        case 19:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 11]]);
  })();
}
function editContractorFiles(_ref3) {
  var payload = _ref3.payload,
    _ref3$callback = _ref3.callback,
    callback = _ref3$callback === void 0 ? _helpers.identity : _ref3$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    var response, _response2$data, _response2$data2, _response2;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.call)(_Contractor.ContractorService.editFiles, payload);
        case 3:
          response = _context2.sent;
          _context2.next = 6;
          return (0, _effects.put)({
            type: _variables.CONTRACTORS_EDIT_SUCCESS,
            payload: response
          });
        case 6:
          _context2.next = 8;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Contractor edited successfully'
            }
          });
        case 8:
          callback();
          _context2.next = 19;
          break;
        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](0);
          _response2 = _context2.t0.response;
          _context2.next = 16;
          return (0, _effects.put)({
            type: _variables.CONTRACTORS_EDIT_FAIL,
            payload: _response2
          });
        case 16:
          _context2.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response2$data = _response2 === null || _response2 === void 0 ? void 0 : _response2.data) !== null && _response2$data !== void 0 ? _response2$data : {}),
              data: _response2
            }
          });
        case 18:
          (0, _utils.logErr)((_response2$data2 = _response2 === null || _response2 === void 0 ? void 0 : _response2.data) !== null && _response2$data2 !== void 0 ? _response2$data2 : {});
        case 19:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 11]]);
  })();
}
function getContractor(_ref5) {
  var payload = _ref5.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
    var response, _response3$data, _response3$data2, _response3;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.call)(_Contractor.ContractorService.get, payload);
        case 3:
          response = _context3.sent;
          _context3.next = 6;
          return (0, _effects.put)({
            type: _variables.CONTRACTORS_GET_SUCCESS,
            payload: response
          });
        case 6:
          _context3.next = 16;
          break;
        case 8:
          _context3.prev = 8;
          _context3.t0 = _context3["catch"](0);
          _response3 = _context3.t0.response;
          _context3.next = 13;
          return (0, _effects.put)({
            type: _variables.CONTRACTORS_GET_FAIL,
            payload: _response3
          });
        case 13:
          _context3.next = 15;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response3$data = _response3 === null || _response3 === void 0 ? void 0 : _response3.data) !== null && _response3$data !== void 0 ? _response3$data : {}),
              data: _response3
            }
          });
        case 15:
          (0, _utils.logErr)((_response3$data2 = _response3 === null || _response3 === void 0 ? void 0 : _response3.data) !== null && _response3$data2 !== void 0 ? _response3$data2 : {});
        case 16:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 8]]);
  })();
}
function deleteContractor(_ref7) {
  var payload = _ref7.payload,
    _ref7$callback = _ref7.callback,
    callback = _ref7$callback === void 0 ? _helpers.identity : _ref7$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
    var response, _response4$data, _response4$data2, _response4;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return (0, _effects.call)(_Contractor.ContractorService["delete"], payload);
        case 3:
          response = _context4.sent;
          _context4.next = 6;
          return (0, _effects.put)({
            type: _variables.CONTRACTORS_DELETE_SUCCESS,
            payload: response
          });
        case 6:
          _context4.next = 8;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Contractor deleted successfully'
            }
          });
        case 8:
          callback();
          _context4.next = 19;
          break;
        case 11:
          _context4.prev = 11;
          _context4.t0 = _context4["catch"](0);
          _response4 = _context4.t0.response;
          _context4.next = 16;
          return (0, _effects.put)({
            type: _variables.CONTRACTORS_DELETE_FAIL,
            payload: _response4
          });
        case 16:
          _context4.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response4$data = _response4 === null || _response4 === void 0 ? void 0 : _response4.data) !== null && _response4$data !== void 0 ? _response4$data : {}),
              data: _response4
            }
          });
        case 18:
          (0, _utils.logErr)((_response4$data2 = _response4 === null || _response4 === void 0 ? void 0 : _response4.data) !== null && _response4$data2 !== void 0 ? _response4$data2 : {});
        case 19:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[0, 11]]);
  })();
}
function listContractors(_ref9) {
  var payload = _ref9.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
    var response, _response5$data, _response5$data2, _response5;
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return (0, _effects.call)(_Contractor.ContractorService.list, payload);
        case 3:
          response = _context5.sent;
          _context5.next = 6;
          return (0, _effects.put)({
            type: _variables.CONTRACTORS_LIST_SUCCESS,
            payload: response
          });
        case 6:
          _context5.next = 16;
          break;
        case 8:
          _context5.prev = 8;
          _context5.t0 = _context5["catch"](0);
          _response5 = _context5.t0.response;
          _context5.next = 13;
          return (0, _effects.put)({
            type: _variables.CONTRACTORS_LIST_FAIL,
            payload: _response5
          });
        case 13:
          _context5.next = 15;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response5$data = _response5 === null || _response5 === void 0 ? void 0 : _response5.data) !== null && _response5$data !== void 0 ? _response5$data : {}),
              data: _response5
            }
          });
        case 15:
          (0, _utils.logErr)((_response5$data2 = _response5 === null || _response5 === void 0 ? void 0 : _response5.data) !== null && _response5$data2 !== void 0 ? _response5$data2 : {});
        case 16:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[0, 8]]);
  })();
}
function createContractor(_ref11) {
  var payload = _ref11.payload,
    _ref11$callback = _ref11.callback,
    callback = _ref11$callback === void 0 ? _helpers.identity : _ref11$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
    var response, _response6$data, _response6$data2, _response6;
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return (0, _effects.call)(_Contractor.ContractorService.create, payload);
        case 3:
          response = _context6.sent;
          _context6.next = 6;
          return (0, _effects.put)({
            type: _variables.CONTRACTORS_CREATE_SUCCESS,
            payload: response
          });
        case 6:
          _context6.next = 8;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Contractor created successfully'
            }
          });
        case 8:
          callback();
          _context6.next = 19;
          break;
        case 11:
          _context6.prev = 11;
          _context6.t0 = _context6["catch"](0);
          _response6 = _context6.t0.response;
          _context6.next = 16;
          return (0, _effects.put)({
            type: _variables.CONTRACTORS_CREATE_FAIL,
            payload: _response6
          });
        case 16:
          _context6.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response6$data = _response6 === null || _response6 === void 0 ? void 0 : _response6.data) !== null && _response6$data !== void 0 ? _response6$data : {}),
              data: _response6
            }
          });
        case 18:
          (0, _utils.logErr)((_response6$data2 = _response6 === null || _response6 === void 0 ? void 0 : _response6.data) !== null && _response6$data2 !== void 0 ? _response6$data2 : {});
        case 19:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[0, 11]]);
  })();
}
function createContractorType(_ref13) {
  var payload = _ref13.payload,
    meta = _ref13.meta;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee7() {
    var response, _response7$data, _response7$data2, _response7;
    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return (0, _effects.call)(_Contractor.ContractorService.createContractorType, payload);
        case 3:
          response = _context7.sent;
          _context7.next = 6;
          return (0, _effects.put)({
            type: _variables.CREATE_CONTRACTOR_TYPE_SUCCESS,
            payload: response
          });
        case 6:
          _context7.next = 8;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Contractor type created successfully'
            }
          });
        case 8:
          meta === null || meta === void 0 || meta.callback();
          _context7.next = 19;
          break;
        case 11:
          _context7.prev = 11;
          _context7.t0 = _context7["catch"](0);
          _response7 = _context7.t0.response;
          _context7.next = 16;
          return (0, _effects.put)({
            type: _variables.CREATE_CONTRACTOR_TYPE_FAIL,
            payload: _response7
          });
        case 16:
          _context7.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response7$data = _response7 === null || _response7 === void 0 ? void 0 : _response7.data) !== null && _response7$data !== void 0 ? _response7$data : {}),
              data: _response7
            }
          });
        case 18:
          (0, _utils.logErr)((_response7$data2 = _response7 === null || _response7 === void 0 ? void 0 : _response7.data) !== null && _response7$data2 !== void 0 ? _response7$data2 : {});
        case 19:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[0, 11]]);
  })();
}
function editContractorType(_ref15) {
  var payload = _ref15.payload,
    meta = _ref15.meta;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
    var response, _response8$data, _response8$data2, _response8;
    return _regenerator["default"].wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.prev = 0;
          _context8.next = 3;
          return (0, _effects.call)(_Contractor.ContractorService.editContractorType, payload);
        case 3:
          response = _context8.sent;
          _context8.next = 6;
          return (0, _effects.put)({
            type: _variables.EDIT_CONTRACTOR_TYPE_SUCCESS,
            payload: response
          });
        case 6:
          _context8.next = 8;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Contractor type edited successfully'
            }
          });
        case 8:
          meta === null || meta === void 0 || meta.callback();
          _context8.next = 19;
          break;
        case 11:
          _context8.prev = 11;
          _context8.t0 = _context8["catch"](0);
          _response8 = _context8.t0.response;
          _context8.next = 16;
          return (0, _effects.put)({
            type: _variables.EDIT_CONTRACTOR_TYPE_FAIL,
            payload: _response8
          });
        case 16:
          _context8.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response8$data = _response8 === null || _response8 === void 0 ? void 0 : _response8.data) !== null && _response8$data !== void 0 ? _response8$data : {}),
              data: _response8
            }
          });
        case 18:
          (0, _utils.logErr)((_response8$data2 = _response8 === null || _response8 === void 0 ? void 0 : _response8.data) !== null && _response8$data2 !== void 0 ? _response8$data2 : {});
        case 19:
        case "end":
          return _context8.stop();
      }
    }, _callee8, null, [[0, 11]]);
  })();
}
function deleteContractorType(_ref17) {
  var payload = _ref17.payload,
    meta = _ref17.meta;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee9() {
    var response, _response9$data, _response9$data2, _response9;
    return _regenerator["default"].wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.prev = 0;
          _context9.next = 3;
          return (0, _effects.call)(_Contractor.ContractorService.deleteContractorType, payload);
        case 3:
          response = _context9.sent;
          _context9.next = 6;
          return (0, _effects.put)({
            type: _variables.DELETE_CONTRACTOR_TYPE_SUCCESS,
            payload: response
          });
        case 6:
          _context9.next = 8;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Contractor type deleted successfully'
            }
          });
        case 8:
          meta === null || meta === void 0 || meta.callback();
          _context9.next = 19;
          break;
        case 11:
          _context9.prev = 11;
          _context9.t0 = _context9["catch"](0);
          _response9 = _context9.t0.response;
          _context9.next = 16;
          return (0, _effects.put)({
            type: _variables.DELETE_CONTRACTOR_TYPE_FAIL,
            payload: _response9
          });
        case 16:
          _context9.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response9$data = _response9 === null || _response9 === void 0 ? void 0 : _response9.data) !== null && _response9$data !== void 0 ? _response9$data : {}),
              data: _response9
            }
          });
        case 18:
          (0, _utils.logErr)((_response9$data2 = _response9 === null || _response9 === void 0 ? void 0 : _response9.data) !== null && _response9$data2 !== void 0 ? _response9$data2 : {});
        case 19:
        case "end":
          return _context9.stop();
      }
    }, _callee9, null, [[0, 11]]);
  })();
}
function listContractorTypes(_ref19) {
  var payload = _ref19.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee10() {
    var response, _response10$data, _response10$data2, _response10;
    return _regenerator["default"].wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _context10.prev = 0;
          _context10.next = 3;
          return (0, _effects.call)(_Contractor.ContractorService.listContractorTypes, payload);
        case 3:
          response = _context10.sent;
          _context10.next = 6;
          return (0, _effects.put)({
            type: _variables.LIST_CONTRACTOR_TYPE_SUCCESS,
            payload: response
          });
        case 6:
          _context10.next = 16;
          break;
        case 8:
          _context10.prev = 8;
          _context10.t0 = _context10["catch"](0);
          _response10 = _context10.t0.response;
          _context10.next = 13;
          return (0, _effects.put)({
            type: _variables.LIST_CONTRACTOR_TYPE_FAIL,
            payload: _response10
          });
        case 13:
          _context10.next = 15;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response10$data = _response10 === null || _response10 === void 0 ? void 0 : _response10.data) !== null && _response10$data !== void 0 ? _response10$data : {}),
              data: _response10
            }
          });
        case 15:
          (0, _utils.logErr)((_response10$data2 = _response10 === null || _response10 === void 0 ? void 0 : _response10.data) !== null && _response10$data2 !== void 0 ? _response10$data2 : {});
        case 16:
        case "end":
          return _context10.stop();
      }
    }, _callee10, null, [[0, 8]]);
  })();
}
function enableContractorType(_ref21) {
  var payload = _ref21.payload,
    meta = _ref21.meta;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee11() {
    var response, _response11$data, _response11$data2, _response11;
    return _regenerator["default"].wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          _context11.prev = 0;
          _context11.next = 3;
          return (0, _effects.call)(_Contractor.ContractorService.enableContractorType, payload);
        case 3:
          response = _context11.sent;
          _context11.next = 6;
          return (0, _effects.put)({
            type: _variables.ENABLE_CONTRACTOR_TYPE_SUCCESS,
            payload: response
          });
        case 6:
          _context11.next = 8;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Contractor type enabled successfully'
            }
          });
        case 8:
          meta === null || meta === void 0 || meta.callback();
          _context11.next = 19;
          break;
        case 11:
          _context11.prev = 11;
          _context11.t0 = _context11["catch"](0);
          _response11 = _context11.t0.response;
          _context11.next = 16;
          return (0, _effects.put)({
            type: _variables.ENABLE_CONTRACTOR_TYPE_FAIL,
            payload: _response11
          });
        case 16:
          _context11.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response11$data = _response11 === null || _response11 === void 0 ? void 0 : _response11.data) !== null && _response11$data !== void 0 ? _response11$data : {}),
              data: _response11
            }
          });
        case 18:
          (0, _utils.logErr)((_response11$data2 = _response11 === null || _response11 === void 0 ? void 0 : _response11.data) !== null && _response11$data2 !== void 0 ? _response11$data2 : {});
        case 19:
        case "end":
          return _context11.stop();
      }
    }, _callee11, null, [[0, 11]]);
  })();
}
function disableContractorType(_ref23) {
  var payload = _ref23.payload,
    meta = _ref23.meta;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee12() {
    var response, _response12$data, _response12$data2, _response12;
    return _regenerator["default"].wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _context12.prev = 0;
          _context12.next = 3;
          return (0, _effects.call)(_Contractor.ContractorService.disableContractorType, payload);
        case 3:
          response = _context12.sent;
          _context12.next = 6;
          return (0, _effects.put)({
            type: _variables.DISABLE_CONTRACTOR_TYPE_SUCCESS,
            payload: response
          });
        case 6:
          _context12.next = 8;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Contractor type disabled successfully'
            }
          });
        case 8:
          meta === null || meta === void 0 || meta.callback();
          _context12.next = 19;
          break;
        case 11:
          _context12.prev = 11;
          _context12.t0 = _context12["catch"](0);
          _response12 = _context12.t0.response;
          _context12.next = 16;
          return (0, _effects.put)({
            type: _variables.DISABLE_CONTRACTOR_TYPE_FAIL,
            payload: _response12
          });
        case 16:
          _context12.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response12$data = _response12 === null || _response12 === void 0 ? void 0 : _response12.data) !== null && _response12$data !== void 0 ? _response12$data : {}),
              data: _response12
            }
          });
        case 18:
          (0, _utils.logErr)((_response12$data2 = _response12 === null || _response12 === void 0 ? void 0 : _response12.data) !== null && _response12$data2 !== void 0 ? _response12$data2 : {});
        case 19:
        case "end":
          return _context12.stop();
      }
    }, _callee12, null, [[0, 11]]);
  })();
}
function contractorsWatcher() {
  return _regenerator["default"].wrap(function contractorsWatcher$(_context13) {
    while (1) switch (_context13.prev = _context13.next) {
      case 0:
        _context13.next = 2;
        return (0, _effects.all)([(0, _effects.takeLatest)(_variables.CONTRACTORS_GET_REQUEST, getContractor), (0, _effects.takeLatest)(_variables.CONTRACTORS_EDIT_REQUEST, editContractor), (0, _effects.takeLatest)(_variables.CONTRACTORS_EDIT_FILES_REQUEST, editContractorFiles), (0, _effects.takeLatest)(_variables.CONTRACTORS_LIST_REQUEST, listContractors), (0, _effects.takeLatest)(_variables.CONTRACTORS_CREATE_REQUEST, createContractor), (0, _effects.takeLatest)(_variables.CONTRACTORS_DELETE_REQUEST, deleteContractor), (0, _effects.takeLatest)(_variables.CREATE_CONTRACTOR_TYPE_REQUEST, createContractorType), (0, _effects.takeLatest)(_variables.DELETE_CONTRACTOR_TYPE_REQUEST, deleteContractorType), (0, _effects.takeLatest)(_variables.EDIT_CONTRACTOR_TYPE_REQUEST, editContractorType), (0, _effects.takeLatest)(_variables.LIST_CONTRACTOR_TYPE_REQUEST, listContractorTypes), (0, _effects.takeLatest)(_variables.ENABLE_CONTRACTOR_TYPE_REQUEST, enableContractorType), (0, _effects.takeLatest)(_variables.DISABLE_CONTRACTOR_TYPE_REQUEST, disableContractorType)]);
      case 2:
      case "end":
        return _context13.stop();
    }
  }, _marked);
}